module.exports = __webpack_public_path__ + "img/DSCF0268.b492094c.png";